import routes from "@/constants/routes";
import { SubLayout } from "@/containers/layout/LandingLayout";
import Link from "next/link";

const KnowYourBudget = (): JSX.Element => {
  return (
    <div className="relative px-5 lg:pr-10 h-full w-full">
      <section className="relative z-30 flex flex-col items-center justify-center w-full mx-auto text-white mt-9 md:mt-5 md:-top-5 xl:-top-6 py-9 px-5 md:h-40 xl:h-60 rounded-2xl p-14 bg-landing-denim">
        <h2 className="text-3xl font-bold text-center xl:text-5xl max-w-[360px] md:max-w-fit">
          Know your budget?
        </h2>

        <div className="flex flex-col items-center justify-center align-middle text-center md:mt-5 lg:mt-2 xl:mt-5 md:flex-row lg:flex-col xl:flex-row w-full">
          <p className="my-6 font-serif text-lg md:text-xl font-normal md:my-auto xl:text-2xl whitespace-nowrap">
            Calculate your monthly budget
          </p>
          <div className="hidden w-px min-w-[1px] h-12 bg-white md:mx-6 xl:mx-8 md:flex lg:hidden xl:flex" />
          <Link href={routes.calculator} scroll={false}>
            <a className="block min-w-[8.5rem] w-full px-4 py-3 text-base font-bold text-center text-white transition duration-300 ease-in-out transform rounded shadow cursor-pointer lg:mt-2 xl:mt-0 md:w-max bg-landing-orange hover:scale-105 ">
              Calculate
            </a>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default KnowYourBudget;
